module.exports = __webpack_public_path__ + "static/img/dot_logo.88c4a12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dot_logo.png
// module id = Pluj
// module chunks = 27